import { render, staticRenderFns } from "./RoomUpdate.vue?vue&type=template&id=6ae1afb4&scoped=true&"
import script from "./RoomUpdate.vue?vue&type=script&lang=ts&"
export * from "./RoomUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./RoomUpdate.vue?vue&type=style&index=0&id=6ae1afb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1afb4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae1afb4')) {
      api.createRecord('6ae1afb4', component.options)
    } else {
      api.reload('6ae1afb4', component.options)
    }
    module.hot.accept("./RoomUpdate.vue?vue&type=template&id=6ae1afb4&scoped=true&", function () {
      api.rerender('6ae1afb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomUpdate.vue"
export default component.exports